import { render, staticRenderFns } from "./FormDspPartner.vue?vue&type=template&id=54632051&"
import script from "./FormDspPartner.vue?vue&type=script&lang=js&"
export * from "./FormDspPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports